/* eslint-disable @next/next/no-img-element */
import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/Search";
import ButtonPrimary from "../../ui/button/ButtonPrimary";
import MenuPrimary from "../../ui/menu/MenuPrimary";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { useRouter } from "next/router";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import PersonIcon from "@mui/icons-material/Person";
import { observer } from "mobx-react-lite";
import { useStore } from "../../../context/store";
import * as idb from 'idb-keyval';

const NavbarDash = () => {
  const router = useRouter();
  const { ApiStore } = useStore();
  // const [search, setsearch] = useState("");

  const [userData, setUserData] = useState(null);
  const [userToken, setUserToken] = useState(null);

  async function handleLogout() {
    if (typeof window !== "undefined") {
      setUserData(null);
      const keys = await idb.keys()
      const filteredKeys = keys.filter((key) => key === "sketshare_userdata" || "sketshare_usertoken")
      await idb.delMany(filteredKeys).then(() => console.log("logout successfully"))
      window.localStorage.removeItem("sketshare_user");
      router.push("/");
    }
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      const data = JSON.parse(window.localStorage.getItem("sketshare_user"));
      setUserData(data?.user);
      setUserToken(data?.token);
    }
  }, []);

  // const user = typeof window !== "undefined" && JSON.parse(localStorage.getItem("sketshare_user"));
  return (
    <div className="navbar-dash">
      <div className="left">
        {router.pathname === "/dashboard" || router.pathname === "/shared_with_me" ? (
          <div className="input">
            <SearchIcon className="icon" />
            <input
              type="text"
              placeholder="Search boards"
              value={ApiStore.searchDashboard}
              onChange={(e) => ApiStore.setsearchDashboard(e.target.value)}
            />
          </div>
        ) : null}
      </div>
      <div className="right">
        {/* <ButtonPrimary icon={<AddIcon />} text="Invite members" className="outlined" /> */}
        {/* <ButtonPrimary text="Upgrade" icon={<WorkspacePremiumIcon />} onClick={() => { }} /> */}

        {/* <Tooltip title="Help" className="mr-2">
          <ButtonBase className="icon">
            <QuestionMarkIcon />
          </ButtonBase>
        </Tooltip>
        <Tooltip title="Notifications" className="mr-2">
          <ButtonBase className="icon">
            <NotificationsIcon />
          </ButtonBase>
        </Tooltip> */}

        <MenuPrimary
          className="avatar"
          label={userData?.first_name ? userData.first_name : userData?.name}
          icon={userData && userData.profile ? <img src={`${userData.profile}?token=${userToken}`} alt="user" /> : <PersonIcon />}
          data={[
            {
              name: "Home",
              icon: <HomeOutlinedIcon sx={{ marginRight: "0.5rem" }} />,
              onClick: () => router.push("/"),
            },
            // { divider: true },
            {
              name: "Log out",
              icon: <LogoutOutlinedIcon sx={{ marginRight: "0.5rem" }} />,
              onClick: handleLogout
            },
          ]}
        />
      </div>
    </div>
  );
};

export default observer(NavbarDash);
